/* Public endpoint that already feeds the marketing site map. It answers with
   `access-control-allow-origin: *`, so the browser can read it directly and this
   page needs no backend of its own. */
const DEFAULT_STATIONS_URL = 'https://services.vammo.com/v1/public-swap-stations/map';

export const config = {
  stationsUrl: import.meta.env.VITE_STATIONS_URL ?? DEFAULT_STATIONS_URL,
  /* Digits only, country code included, e.g. 5511999999999. Empty hides the CTA
     rather than rendering a broken wa.me link. */
  whatsappNumber: import.meta.env.VITE_WHATSAPP_NUMBER ?? '',
  gtmId: import.meta.env.VITE_GTM_ID ?? '',
};
